export const ORG_TYPES = {
    Company: 1,
    IndividualEntrepreneur: 2,
    SelfEmployed: 3,
};


// WEBPACK FOOTER //
// ./src/modules/sign/Register/constants.js